import React from "react";
import Products from "../../Components/Products";

const MainProducts = () => {
	return <Products />;
};

export default MainProducts;
